export const onKeyDown = (_: any, e: any) => {
    if (e.key !== 'Backspace') {
        return true;
    }

    let target = e.srcElement || e.target;
    let myLength = target.value.length;
    if (myLength === 0) {
        let previous = target;
        while (previous = previous.previousElementSibling) {
            if (previous == null)
                break;
            if (previous.tagName.toLowerCase() === 'input') {
                previous.focus();
                const event = new KeyboardEvent('keydown', {
                    key: 'Backspace'
                });
                previous.dispatchEvent(event);
                break;
            }
        }
    }

    return true;
}

export const onInput = (_: any, e: any) => {
    if (e.inputType && e.inputType.startsWith('insert')) {
        const target = e.srcElement || e.target;
        const maxLength = parseInt(target.attributes['maxlength'].value, 10);
        const myLength = target.value.length;
        if (myLength >= maxLength) {
            let next = target;
            while (next = next.nextElementSibling) {
                if (next == null)
                    break;
                if (next.tagName.toLowerCase() === 'input') {
                    next.focus();
                    break;
                }
            }
        }
    }

    return true;
}